import api from './api';

// Interface base para Anunciante
export interface Anunciante {
  id: number;
  nome: string;
  dataremocao?: string;
  principal_id?: number;
  mongo_principal?: string;
}

// Interface para criação de Anunciante
export interface AnuncianteCreate {
  nome: string;
  principal_id?: number;
  mongo_principal?: string;
}

// Interface para atualização de Anunciante
export interface AnuncianteUpdate {
  nome?: string;
  principal_id?: number;
  mongo_principal?: string;
}

// Interface para filtros de busca
export interface AnuncianteFilter {
  nome?: string;
  principal_id?: number;
}

const AnunciantesService = {
  // Obter lista de anunciantes com filtragem e paginação
  getAnunciantes: async (filter: AnuncianteFilter = {}, skip: number = 0, limit: number = 10): Promise<Anunciante[]> => {
    try {
      const response = await api.get('/anunciantes/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar anunciantes:', error);
      throw error;
    }
  },

  // Obter anunciante por ID
  getAnuncianteById: async (id: number): Promise<Anunciante> => {
    try {
      const response = await api.get(`/anunciantes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar anunciante ${id}:`, error);
      throw error;
    }
  },

  // Criar novo anunciante
  createAnunciante: async (anunciante: AnuncianteCreate): Promise<Anunciante> => {
    try {
      const response = await api.post('/anunciantes/', anunciante);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar anunciante:', error);
      throw error;
    }
  },

  // Atualizar anunciante existente
  updateAnunciante: async (id: number, anunciante: AnuncianteUpdate): Promise<Anunciante> => {
    try {
      const response = await api.put(`/anunciantes/${id}`, anunciante);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar anunciante ${id}:`, error);
      throw error;
    }
  },

  // Excluir anunciante
  deleteAnunciante: async (id: number): Promise<void> => {
    try {
      await api.delete(`/anunciantes/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir anunciante ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getAnunciantesCount: async (filter: AnuncianteFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/anunciantes/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de anunciantes:', error);
      throw error;
    }
  },

  // Obter todos os anunciantes (para uso em selects/dropdowns)
  getAllAnunciantes: async (): Promise<Anunciante[]> => {
    try {
      const response = await api.get('/anunciantes/all/list');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar todos os anunciantes:', error);
      throw error;
    }
  }
};

export default AnunciantesService;
